import { useApiCreate, useApiDelete, useApiList } from '@/composables/api'
import { UserBlock } from '@/model/data-object/UserBlock'
import { UserBlockHasUser } from '@/model/data-object/UserBlockHasUser'
import useConfiguration from '@/composables/configuration/configuration'

const { configuration } = useConfiguration()

async function blockUser(userId: number): Promise<UserBlockHasUser> {
  const { request, response, error } = useApiCreate<UserBlockHasUser>(
    '/api/prv/v1/userBlock/' + userId,
    {}
  )
  await request()

  if (typeof error.value !== 'undefined') {
    throw error.value
  }

  return response.value as UserBlockHasUser
}

async function unblockUser(userId: number): Promise<void> {
  const { request } = useApiDelete<UserBlock>('/api/prv/v1/userBlock/' + userId)
  await request()

  return
}

async function getBlockedUserIds(): Promise<Array<number>> {
  const { request, response } = useApiList<Array<number>>(
    '/api/prv/v1/userBlock/blocked/ids'
  )
  await request()

  if (response.value) {
    return response.value
  }

  return []
}

function getBlockedUsers(offset: number) {
  return useApiList<Array<UserBlock>>('/api/prv/v1/userBlock/blocked/users', {
    params: {
      offset: offset,
      limit: configuration.profilePageSize,
    },
  })
}

export default function useUserBlockApi() {
  return {
    blockUser,
    unblockUser,
    getBlockedUserIds,
    getBlockedUsers,
  }
}
